import { render, staticRenderFns } from "./FormSubphasePicker.vue?vue&type=template&id=70393144&"
import script from "./FormSubphasePicker.vue?vue&type=script&lang=ts&"
export * from "./FormSubphasePicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports